export const initialState = {
    loading: false,
    showSuccess: false,
    errorMessage: '',
    errorType: '',
    businessUnits: [],
    collections: [],
    collectionWithLicenseInformation: [],
    competencies: [],
    competencyAreas: [],
    departments: [],
    integrationFields: [],
    locations: [],
    profiles: [],
    profileGroups: [],
    roles: [],
    crmJobs: [],
    settings: { loading: true },
    tags: [],
};
